import React from 'react';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';

const LargeTextField = (props) => {
  const { pdfUrlLink } = props;

  const [pdfUrl, setPdfURL] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (pdfUrlLink && pdfUrlLink !== '') {
      setPdfURL(pdfUrlLink);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [pdfUrlLink]);

  return (
    <div>
      <Spinner load={loading} />
      <div className="mt-4" data-testid="id-for-preview">
        {pdfUrl && pdfUrl !== '' ? (
          <>
            <embed
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              type="application/pdf"
              frameBorder="0"
              scrolling="auto"
              height="500px"
              width="100%"
            />
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
export default LargeTextField;
